/**
 * Every level the game ships, by id. The server builds a room's World on one
 * of these and names it in the `room` frame; the client looks the same id up
 * here so prediction, the camera and the ground use the same map. Each
 * level's data is its own module (arenaLevel.ts, cloisterLevel.ts, fontsLevel.ts),
 * registered in LEVELS.
 */

import type { Arena } from './arena.js';
import { ARENA } from './arena.js';
import { type LevelDef, compileLevel } from './level.js';
import { ARENA_LEVEL } from './arenaLevel.js';
import { CLOISTER_LEVEL } from './cloisterLevel.js';
import { FONTS_LEVEL } from './fontsLevel.js';

/** The level a room plays when nothing else is chosen: the wave arena. */
export const DEFAULT_LEVEL = ARENA_LEVEL.id;

export const LEVELS: Readonly<Record<string, LevelDef>> = {
  [ARENA_LEVEL.id]: ARENA_LEVEL,
  [CLOISTER_LEVEL.id]: CLOISTER_LEVEL,
  [FONTS_LEVEL.id]: FONTS_LEVEL,
};

export function levelById(id: string): LevelDef | undefined {
  return Object.hasOwn(LEVELS, id) ? LEVELS[id] : undefined;
}

const compiled = new Map<string, Arena>([[ARENA.id, ARENA]]);

/** The compiled map of level `id`, built once and shared; an unknown id gives the default arena. */
export function arenaFor(id: string | undefined): Arena {
  const key = id !== undefined && levelById(id) ? id : DEFAULT_LEVEL;
  let a = compiled.get(key);
  if (!a) {
    a = compileLevel(levelById(key) ?? ARENA_LEVEL);
    compiled.set(key, a);
  }
  return a;
}
